import React from 'react';

const Loader = () => {
  return (
    <div class="flex items-center justify-center min-h-screen">
      <div class="w-40 h-40 border-t-4 border-b-4 border-blue-400 rounded-full animate-spin"></div>
    </div>
  );
};

export default Loader;
